import Bugsnag from '@bugsnag/js';

export default {
  initPlayCanvas: function() {
      var canvas, devices, app;

      const getCanvas = function () {
          canvas = document.querySelector('canvas#application-canvas');

          // Disable I-bar cursor on click+drag
          canvas.onselectstart = function () { return false; };

          return canvas;
      };

      var createInputDevices = function (canvas) {
        const devices = {
          elementInput: new window.pc.ElementInput(canvas, {
            useMouse: window.INPUT_SETTINGS.useMouse,
            useTouch: window.INPUT_SETTINGS.useTouch
          }),
          keyboard: window.INPUT_SETTINGS.useKeyboard ? new window.pc.Keyboard(window) : null,
          mouse: window.INPUT_SETTINGS.useMouse ? new window.pc.Mouse(canvas) : null,
          // gamepads: window.INPUT_SETTINGS.useGamepads ? new pc.GamePads() : null,
          touch: window.INPUT_SETTINGS.useTouch && window.pc.platform.touch ? new window.pc.TouchDevice(canvas) : null
        };

        return devices;
      };

      var displayError = function (html) {
        const errorContainer = document.querySelector('#webgl-error');

        errorContainer.innerHTML = html;
        errorContainer.classList.add('show');
      };

      canvas = getCanvas();
      devices = createInputDevices(canvas);

      try {
        app = new window.pc.Application(canvas, {
          elementInput: devices.elementInput,
          keyboard: devices.keyboard,
          mouse: devices.mouse,
          // gamepads: devices.gamepads,
          touch: devices.touch,
          graphicsDeviceOptions: window.CONTEXT_OPTIONS,
          assetPrefix: window.ASSET_PREFIX || '',
          scriptPrefix: window.SCRIPT_PREFIX || '',
          scriptsOrder: window.SCRIPTS || [],
        });
      } catch (e) {
        if (e instanceof window.pc.UnsupportedBrowserError) {
          displayError('This page requires a browser that supports WebGL.<br/>' +
                  '<a href="http://get.webgl.org">Click here to find out more.</a>');
        } else if (e instanceof window.pc.ContextCreationError) {
          displayError("It doesn't appear your computer can support WebGL.<br/>" +
                  '<a href="http://get.webgl.org/troubleshooting/">Click here for more information.</a>');
        } else {
          displayError('Could not initialize application. Error: ' + e);
        }
        Bugsnag.notify(e);

        return;
      }

      var configure = function () {
        app.configure(window.CONFIG_FILENAME, function (err) {
          if (err) {
            console.error(err);
          }

          app.preload(function (err) {
            if (err) {
              console.error(err);
            }

            app.loadScene(window.SCENE_PATH, function (err) {
              if (err) {
                console.error(err);
              }

              app.start();
            });
          });
        });
      };

      if (window.PRELOAD_MODULES.length > 0) {
        window.loadModules(window.PRELOAD_MODULES, window.ASSET_PREFIX, configure);
      } else {
        configure();
      }
  },
};
